/**
 * A collection of utilities to help with page related issues
 * like spacing for toolbars, autoscroll, keepScroll, etc
 */

export function getWebViewEl() {
    return document.querySelector('.diyw') as HTMLElement;
}

let currentTopSpace = 0;

export function makeTopSpace(height: number, keepVisualPosition = false) {
    const webView = getWebViewEl();

    if (!webView) {
        return;
    }

    const translateRule = `translateY(${height}px)`;
    const topBefore = webView.getBoundingClientRect().top;

    webView.style.transform = translateRule;
    webView.style.webkitTransform = translateRule;
    // in happy case when background is top aligned, we can make the magic to
    // remain visually aligned, best effort ...
    if (parseInt(getComputedStyle(document.body).backgroundPositionY, 10) === 0) {
        document.body.style.backgroundPositionY = height + 'px';
    }

    const topAfter = webView.getBoundingClientRect().top;

    currentTopSpace = height;

    if (keepVisualPosition) {
        // compensate the scroll so that things would stay visually in the same place
        const scrollDelta = topAfter - topBefore;
        window.scrollBy(0, scrollDelta);
        const topAfterScroll = webView.getBoundingClientRect().top;
        if (topAfterScroll > topBefore) {
            // then we probably didn't have enough scrollHeight to compensate the scroll
            const scrollCompensation = topAfterScroll - topBefore;
            document.body.style.paddingBottom = scrollCompensation + 'px';
            window.scrollBy(0, scrollCompensation);
        }
    }
}

export function getTopSpace() {
    return currentTopSpace;
}

export function clearTopSpace(keepVisualPosition = false) {
    makeTopSpace(0, keepVisualPosition);
    const webView = getWebViewEl();
    const translateRule = '';
    webView.style.transform = translateRule;
    webView.style.webkitTransform = translateRule;
    document.body.style.backgroundPositionY = '';
    document.body.style.paddingBottom = '';
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/page.ts
 **/